define('main.js',['require','Promise','jquery','owl-carousel','./blocks/header/header','./blocks/features-carousel/features-carousel','./blocks/reviews/reviews','../cloud-web/js/stat','../cloud-web/js/ph.js','../common/js/utm'],function (require) {
    'use strict';

    window.gaCategoryPrefix = 'screenshoter';
    require('Promise');
    require('jquery');
    require('owl-carousel');
    require('./blocks/header/header');
    require('./blocks/features-carousel/features-carousel');
    require('./blocks/reviews/reviews');
    require('../cloud-web/js/stat');
    require('../cloud-web/js/ph.js');
    require('../common/js/utm');
});

